import axios from "../../axiosInstance";
import requests from '../../requests';

import { takeLatest, all, put, call, delay } from "redux-saga/effects";

import { mainActionTypes } from "./main.types";
import {
	fetchDiagramsList,
	fetchDiagramsListSuccess,
	fetchDiagramsListFailure,

	fetchTemplatesListSuccess,
	fetchTemplatesListFailure,

	diagramRenameSuccess,
	diagramRenameFailure,

	diagramCloneSuccess,
	diagramCloneFailure,

	diagramSoftDeleteSuccess,
	diagramSoftDeleteFailure,

	diagramDeleteSuccess,
	diagramDeleteFailure,

	diagramRestoreSuccess,
	diagramRestoreFailure,

	templateCloneSuccess,
	templateCloneFailure,

	invitePeopleSuccess,
	invitePeopleFailure,

	sendFeedbackSuccess,
	sendFeedbackFailure,
} from "./main.actions";

import { showNotify } from "../notify/notify.actions";

export function* fetchDiagramsListRequest() {
	try {
		const { data, error } = yield axios.get(requests.diagrams, {});
		// .then((response) => {
		// 	const {
		// 		data: { result },
		// 	} = response;
		// 	// dispatch(fetchSearchResultsSuccess(result));
		// })
		// .catch((err) => {
		// 	// dispatch(fetchSearchResultsFailure(err.message));
		// });

		if (error) {
			yield put(fetchDiagramsListFailure(error));
		} else {
			yield put(fetchDiagramsListSuccess(data));
		}
	} catch (e) {
		yield put(fetchDiagramsListFailure(e));
	}
}

export function* fetchTemplatesListRequest() {
	try {
		const { data, error } = yield axios.get(requests.fetchTemplatesList, {});
		if (error) {
			yield put(fetchTemplatesListFailure(error));
		} else {
			yield put(fetchTemplatesListSuccess(data));
		}
	} catch (e) {
		yield put(fetchTemplatesListFailure(e));
	}
}

export function* diagramRenameRequest({ payload: { id, body } }) {
	try {
		yield put(showNotify({ message: 'Saving...' }));
		const url = `${requests.diagramChanges}/${id}/rename`;
		const { data, error } = yield axios.post(url, body);
		if (error) {
			yield put(diagramRenameFailure(error));
			yield put(showNotify({ message: 'Something went wrong. Please try to reload the page.' }));
		} else {
			yield put(diagramRenameSuccess(id));
			yield put(showNotify({ message: 'Saved' }));
			yield put(fetchDiagramsList());
		}
	} catch (e) {
		yield put(diagramRenameFailure(e));
		yield put(showNotify({ message: 'Something went wrong. Please try to reload the page.' }));
	}
}

export function* diagramCloneRequest({ payload: { id, name } }) {
	try {
		yield put(showNotify({ message: 'Duplicating...' }));
		const url = `${requests.diagramChanges}/${id}/clone`;
		const { data, error } = yield axios.post(url, { title: name });
		if (error) {
			yield put(diagramCloneFailure(error));
			yield put(showNotify({ message: 'Something went wrong. Please try to reload the page.' }));
		} else {
			yield put(diagramCloneSuccess(id, name));
			yield put(showNotify({ message: 'The diagram has been duplicated' }));
			yield put(fetchDiagramsList());
		}
	} catch (e) {
		yield put(diagramCloneFailure(e));
		yield put(showNotify({ message: 'Something went wrong. Please try to reload the page.' }));
	}
}

export function* diagramSoftDeleteRequest({ payload: { id, name } }) {
	try {
		yield put(showNotify({ message: 'Deleting...' }));
		const url = `${requests.diagramChanges}/${id}/archive`;
		const { data, error } = yield axios.post(url, { name });
		if (error) {
			yield put(diagramSoftDeleteFailure(error));
			yield put(showNotify({ message: 'Something went wrong. Please try to reload the page.' }));
		} else {
			yield put(diagramSoftDeleteSuccess(id, name));
			yield put(showNotify({ message: 'The diagram has been archived' }));
			yield put(fetchDiagramsList());
		}
	} catch (e) {
		yield put(diagramSoftDeleteFailure(e));
		yield put(showNotify({ message: 'Something went wrong. Please try to reload the page.' }));
	}
}

export function* diagramDeleteRequest({ payload: { id, name } }) {
	try {
		yield put(showNotify({ message: 'Deleting...' }));
		const url = `${requests.diagramChanges}/${id}`;
		const { data, error } = yield axios.delete(url, { name });
		if (error) {
			yield put(diagramDeleteFailure(error));
			yield put(showNotify({ message: 'Something went wrong. Please try to reload the page.' }));
		} else {
			yield put(diagramDeleteSuccess(id, name));
			yield put(showNotify({ message: 'The diagram has been deleted' }));
			yield put(fetchDiagramsList());
		}
	} catch (e) {
		yield put(diagramDeleteFailure(e));
		yield put(showNotify({ message: 'Something went wrong. Please try to reload the page.' }));
	}
}

export function* diagramRestoreRequest({ payload: { id, name } }) {
	try {
		yield put(showNotify({ message: 'Restoring...' }));
		const url = `${requests.diagramChanges}/${id}/restore`;
		const { data, error } = yield axios.post(url, { name });
		if (error) {
			yield put(diagramRestoreFailure(error));
			yield put(showNotify({ message: 'Something went wrong. Please try to reload the page.' }));
		} else {
			yield put(diagramRestoreSuccess(id, name));
			yield put(showNotify({ message: 'The diagram has been restored' }));
			yield put(fetchDiagramsList());
		}
	} catch (e) {
		yield put(diagramRestoreFailure(e));
		yield put(showNotify({ message: 'Something went wrong. Please try to reload the page.' }));
	}
}

export function* templateCloneRequest({ payload: { id, name } }) {
	try {
		yield put(showNotify({ message: 'Creating...' }));
		const url = `${requests.templateChanges}/${id}/clone`;
		const { data, error } = yield axios.post(url, { title: name });
		if (error) {
			yield put(templateCloneFailure(error));
			yield put(showNotify({ message: 'Something went wrong. Please try to reload the page.' }));
		} else {
			yield put(templateCloneSuccess(id, name));
			yield put(showNotify({ message: 'The diagram has been created' }));
			yield put(fetchDiagramsList());
		}
	} catch (e) {
		yield put(templateCloneFailure(e));
		yield put(showNotify({ message: 'Something went wrong. Please try to reload the page.' }));
	}
}

export function* invitePeopleRequest({ payload: { email } }) {
	try {
		yield put(showNotify({ message: 'Sending...' }));
		const url = `${requests.invitePeople}`;
		const { data, error } = yield axios.post(url, { email });
		if (error) {
			yield put(invitePeopleFailure(error));
			yield put(showNotify({ message: 'Something went wrong. Please try to reload the page.' }));
		} else {
			yield put(invitePeopleSuccess(email));
			yield put(showNotify({ message: 'The invite has been sent' }));
		}
	} catch (e) {
		yield put(invitePeopleFailure(e));
		yield put(showNotify({ message: 'Something went wrong. Please try to reload the page.' }));
	}
}

export function* sendFeedbackRequest({ payload: { data: body } }) {
	try {
		yield put(showNotify({ message: 'Sending...' }));
		const url = `${requests.sendRequest}/feedback`;
		const { data, error } = yield axios.post(url, body);
		if (error) {
			yield put(sendFeedbackFailure(error));
			yield put(showNotify({ message: 'Something went wrong. Please try to reload the page.' }));
		} else {
			yield put(sendFeedbackSuccess());
			yield put(showNotify({ message: 'Request has been sent. Thank you!' }));
		}
	} catch (e) {
		yield put(sendFeedbackFailure(e));
		yield put(showNotify({ message: 'Something went wrong. Please try to reload the page.' }));
	}
}

export function* onFetchDiagramsList() {
	yield takeLatest(mainActionTypes.MAIN_FETCH_DIAGRAMS_LIST_REQUEST, fetchDiagramsListRequest);
}
export function* onFetchTemplatesList() {
	yield takeLatest(mainActionTypes.MAIN_FETCH_TEMPLATES_LIST_REQUEST, fetchTemplatesListRequest);
}
export function* onDiagramRename() {
	yield takeLatest(mainActionTypes.MAIN_DIAGRAM_RENAME_REQUEST, diagramRenameRequest);
}
export function* onDiagramClone() {
	yield takeLatest(mainActionTypes.MAIN_DIAGRAM_CLONE_REQUEST, diagramCloneRequest);
}
export function* onDiagramSoftDelete() {
	yield takeLatest(mainActionTypes.MAIN_DIAGRAM_SOFT_DELETE_REQUEST, diagramSoftDeleteRequest);
}
export function* onDiagramDelete() {
	yield takeLatest(mainActionTypes.MAIN_DIAGRAM_DELETE_REQUEST, diagramDeleteRequest);
}
export function* onDiagramRestore() {
	yield takeLatest(mainActionTypes.MAIN_DIAGRAM_RESTORE_REQUEST, diagramRestoreRequest);
}
export function* onTemplateClone() {
	yield takeLatest(mainActionTypes.MAIN_TEMPLATE_CLONE_REQUEST, templateCloneRequest);
}
export function* onInvitePeople() {
	yield takeLatest(mainActionTypes.INVITE_PEOPLE_REQUEST, invitePeopleRequest);
}
export function* onSendFeedback() {
	yield takeLatest(mainActionTypes.SUPPORT_REQ_REQUEST, sendFeedbackRequest);
}

export function* mainSagas() {
	yield all
		([
			call(onFetchDiagramsList),
			call(onFetchTemplatesList),
			call(onDiagramRename),
			call(onDiagramClone),
			call(onDiagramSoftDelete),
			call(onDiagramDelete),
			call(onDiagramRestore),
			call(onTemplateClone),

			call(onInvitePeople),
			call(onSendFeedback),
		]);
}